import { Facility } from "../types/Structure";
import client from "./axios";

const ADMIN_FACILITIES_BASE_URL =
  "https://internal-api.getmoveapp.com/api/v1/admin/facilities";
const FACILITIES_BASE_URL = "https://internal-api.getmoveapp.com/api/v1/facilities";

export const Facilities = {
  getAdminFacilities: () =>
    client.get<{ list: Facility[] }>(`${ADMIN_FACILITIES_BASE_URL}/get-all`),
  getFacilityById: (id: string) =>
    client.get<{ facility: Facility }>(`${FACILITIES_BASE_URL}/${id}`),
  getFacilityImageUrl: (id: string) =>
    client.get<{ url: string }>(`${FACILITIES_BASE_URL}/get-image-url/${id}`),
  createFacility: (fd: FormData) =>
    client.post<{ url: string }>(`${FACILITIES_BASE_URL}/create`, fd),
  updateFacility: (id: string, fd: FormData) =>
    client.put<{ url: string }>(`${FACILITIES_BASE_URL}/${id}`, fd),
  deleteFacility: (id: string) =>
    client.delete<{ result: string }>(`${FACILITIES_BASE_URL}/${id}`),
};
